import {
  GET_SURVEYCONCEPT,
  GET_SURVEYCONCEPT_FAIL,
  GET_SURVEYCONCEPT_SUCCESS,
  GET_SURVEYCONCEPTS,
  GET_SURVEYCONCEPTS_FAIL,
  GET_SURVEYCONCEPTS_SUCCESS,
  ADD_NEW_SURVEYCONCEPT,
  ADD_SURVEYCONCEPT_SUCCESS,
  ADD_SURVEYCONCEPT_FAIL,
  UPDATE_SURVEYCONCEPT,
  UPDATE_SURVEYCONCEPT_SUCCESS,
  UPDATE_SURVEYCONCEPT_FAIL,
  DELETE_SURVEYCONCEPT,
  DELETE_SURVEYCONCEPT_SUCCESS,
  DELETE_SURVEYCONCEPT_FAIL,
  SET_STATE_SURVEYCONCEPT,
  UPDATE_SURVEYCONCEPT_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_SURVEYCONCEPT,
  payload: loading,
})

export const getSurveyConcepts = ( params ) => ({
  type: GET_SURVEYCONCEPTS,
  payload: { params },
})

export const getSurveyConceptsSuccess = (surveyConcepts, totalPages, currentPage) => ({
  type: GET_SURVEYCONCEPTS_SUCCESS,
  payload: { surveyConcepts:surveyConcepts, total:totalPages, currentPage:currentPage}
})

export const getSurveyConceptsFail = error => ({
  type: GET_SURVEYCONCEPTS_FAIL,
  payload: error,
})

export const addNewSurveyConcept = surveyConcept => ({
  type: ADD_NEW_SURVEYCONCEPT,
  payload: surveyConcept,
})

export const addSurveyConceptSuccess = surveyConcept => ({
  type: ADD_SURVEYCONCEPT_SUCCESS,
  payload: surveyConcept,
})  

export const addSurveyConceptFail = error => ({
  type: ADD_SURVEYCONCEPT_FAIL,
  payload: error,
})

export const updateSurveyConcept = surveyConcept => ({
  type: UPDATE_SURVEYCONCEPT,
  payload: surveyConcept,
})

export const updateSurveyConceptStatus = surveyConcept => ({
  type: UPDATE_SURVEYCONCEPT_STATUS,
  payload: surveyConcept,
})

export const updateSurveyConceptSuccess = surveyConcept => ({
  type: UPDATE_SURVEYCONCEPT_SUCCESS,
  payload: surveyConcept,
})

export const updateSurveyConceptFail = error => ({
  type: UPDATE_SURVEYCONCEPT_FAIL,
  payload: error,
})

export const deleteSurveyConcept = surveyConcept => ({
  type: DELETE_SURVEYCONCEPT,
  payload: surveyConcept,
})

export const deleteSurveyConceptSuccess = id => ({
  type: DELETE_SURVEYCONCEPT_SUCCESS,
  id,
})

export const deleteSurveyConceptFail = error => ({
  type: DELETE_SURVEYCONCEPT_FAIL,
  payload: error,
})

export const getSurveyConcept = () => ({
  type: GET_SURVEYCONCEPT,
})

export const getSurveyConceptSuccess = surveyConcept => ({
  type: GET_SURVEYCONCEPT_SUCCESS,
  payload: surveyConcept,
})

export const getSurveyConceptFail = error => ({
  type: GET_SURVEYCONCEPT_FAIL,
  payload: error,
})
